// import external modules
import { combineReducers } from "redux";
// import internal(own) modules
import driversReducer from "./drivers";
import searchReducer from "./search";
import customizer from "./customizer/";
import employee from "./employee";
import travels from "./travels";
import driver from "./driver";

import { reducer as toastrReducer } from "react-redux-toastr";

const rootReducer = combineReducers({
  toastr: toastrReducer, // <- Mounted at toastr.
  customizer: customizer,
  drivers: driversReducer,
  search: searchReducer,
  employee: employee,
  travels: travels,
  driver: driver,
});

export default rootReducer;
